import React from "react"
import { graphql} from "gatsby"
import Layout from "../components/Layout"
import Hero from "../components/Hero"
import Services from "../components/Services"
import Education from "../components/Education"
import Projects from "../components/Projects"
import Blogs from "../components/Blogs"
import Skills from "../components/Skills"
import Certificates from "../components/Certificates"
import SEO from "../components/SEO"

export default ({ data }) => {
  const {
    allStrapiProjects: { nodes: projects },
    allStrapiBlogs: { nodes: blogs }
  } = data
 

  return <Layout>
      <SEO title="Home" description="Home Page" />
      <Hero />
      <Services /> 
      <Education />
      <Skills />
      {/*<Certificates /> */}
      {/*<Jobs />*/}
      <Projects projects={projects} title="Latest projects" showLink />
      <Blogs blogs={blogs} title="Latest Articles" showLink />
    </Layout>
}

export const query = graphql`
  {
    allStrapiProjects(filter: {featured: {eq: true}}, sort: {fields: strapiId, order: DESC}, limit: 3) {
      nodes {
        github
        id
        description
        title
        url
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        stack {
          id
          name
        }
      }
    }
    allStrapiBlogs(sort: {fields: date, order: ASC}, limit: 3) {
      nodes {
        title
        slug
        content
        description
        date(formatString: "MMMM Do YYYY")
        id
        category
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`